import { render, staticRenderFns } from "./DWS03G04.vue?vue&type=template&id=09c1d485&scoped=true"
import script from "./DWS03G04.vue?vue&type=script&lang=js"
export * from "./DWS03G04.vue?vue&type=script&lang=js"
import style0 from "./DWS03G04.vue?vue&type=style&index=0&id=09c1d485&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c1d485",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09c1d485')) {
      api.createRecord('09c1d485', component.options)
    } else {
      api.reload('09c1d485', component.options)
    }
    module.hot.accept("./DWS03G04.vue?vue&type=template&id=09c1d485&scoped=true", function () {
      api.rerender('09c1d485', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pws/DWS03G04.vue"
export default component.exports